<template>
  <div class="routerInfo" v-loading="loading" >
    <div  class="container-fluid container-panel container-mainblock">
      <div class="container">
        <div class="container-head">
          <div class="mainblock-left">
            <a  class="mainblock-label">视频详情</a>
          </div>
        </div>
        <div class="container-body panel-party">
          <div class="news-detail">
            <div class="news-detail-title" >{{videoInfo.videoNewsTitle}}</div>

            <div class="news-detail-content">
              <div class="news-detail-head" style="width: 100%;">
                <div style="text-align: right;flex: 1" class="detail-date"><span >{{videoInfo.pushDate | formatDate}}</span></div>
                <!--                         <div class="detail-record"><img class="list-icon" src="images/record.png" ><span id="viewCount"></span></div> -->
              </div>
              <div class="item-video">
                <video-player style="width:640px;height:360px;"
                              class="vjs-custom-skin videoPlayer"
                               ref="videoPlayer"
                               :playsinline="true"
                               :options="playerOptions"
                ></video-player>
              </div>

              <div class="news-detail-head" style="width: 100%;margin-top: 20px;margin-bottom: 5px">
                <div style="text-align: right;flex: 1" class="detail-date"><span >作者：{{videoInfo.videoAuthor }}</span></div>
                <!--                         <div class="detail-record"><img class="list-icon" src="images/record.png" ><span id="viewCount"></span></div> -->
              </div>
              <div class="news-detail-head" style="width: 100%;display: flex;align-items: end">
                <div style="text-align: right;flex: 1" class="detail-date"><span >来源：{{videoInfo.source }}</span></div>
                <!--                         <div class="detail-record"><img class="list-icon" src="images/record.png" ><span id="viewCount"></span></div> -->
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style rel='stylesheet/less' lang='less' scoped>
  @import "../../assets/less/variables.less";
  @import "../../assets/less/mySearch.less";
  @import "../../assets/less/style.less";
</style>

<script type="text/ecmascript-6">
  import viewFunction from "../../assets/js/viewFunction";
  import { mapState, mapGetters } from 'vuex'
  const moment = require('moment')
  require('video.js/dist/video-js.css')
  require('vue-video-player/src/custom-theme.css')
  export default {
    name: 'Training',
    inject:['findUserScore'],
    data(){
      return {
        //url:'http://121.89.210.255:8080/jinneng/',
        url:'https://www.jnjtzxpx.com/jinneng/',
        newsList: [],
        newsId: '',
        videoInfo: {},
        loading:true,
        startViewTime: null,
        playerOptions : {
          playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
          autoplay: false, //如果true,浏览器准备好时开始回放。
          muted: false, // 默认情况下将会消除任何音频。
          loop: false, // 导致视频一结束就重新开始。
          preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
          language: 'zh-CN',
          aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
          fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
          sources: [{
            type: "video/mp4",//这里的种类支持很多种：基本视频格式、直播、流媒体等，具体可以参看git网址项目
            src: ""
          }],
          poster: "../../static/images/test.jpg", //你的封面地址
          // width: document.documentElement.clientWidth, //播放器宽度
          notSupportedMessage: '视频加载中', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
          controlBar: {
            timeDivider: true,
            durationDisplay: true,
            remainingTimeDisplay: false,
            fullscreenToggle: true  //全屏按钮
          }
        },
        detailData: {}
      }
    },
    filters: {
      formatDate (val) {
        if (val!==null){
          return moment(val).format('YYYY-MM-DD')
        }
        return ''
      }
    },
    computed: {
      ...mapState({
        user: state => state.user
      }),
      ...mapGetters({
        navigationList: 'navs'
      })
    },
    mounted() {
      this.newsId = this.$route.query.videoNewsId
      this.findAllData()
      this.startViewTime = new Date()
    },
    methods:{
      findAllData(){
        let url = '/api/videoViewRecord/findVideoNewsAndRecord'
        let that = this
        let params = {
          videoNewsId: this.newsId
        }

        this.axios.post(url,params).then(res =>viewFunction.handlerRes(that,res,function (){
          that.videoInfo = res.data
          that.loading = false
          that.playerOptions.sources[0].src = res.data.videoNewsUrl
          that.playerOptions.poster = that.url+res.data.videoImageUrl
        }))

        setTimeout(()=>{
          that.addRecord()
        },5*60*1000)
      },
      addRecord(){
        let that = this
        let url = '/api/videoViewRecord/addVideoViewRecord'
        let params = {
          companyId: that.user.businessCompanyId,
          departmentId: that.user.departmentId,
          userId: that.user.userId,
          videoNewsId: that.newsId,
          newsType: 2,
          startViewTime:that.startViewTime,
          endViewTime: new Date(),
          learnTime: 301,
          canGetScore: true
        }
        that.axios.post(url,params).then(res =>{
          that.findUserScore()
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/learn/VideoDetail.vue